import * as service from './OrganizationDetails.service.js'

export default {
  data() {
    return {
      Certificationcolumns: ['Name', 'Description', 'Actions'],
      optionstable: {

        headings: {
          Name: 'Name',
          Description: 'Description',
          edit: 'Edit',
          delete: 'Delete'

        },
        sortIcon: {
          base: 'glyphicon',
          up: 'glyphicon-chevron-up',
          down: 'glyphicon-chevron-down'
        },
        sortable: ['Name', 'Description'],
        texts: {

          filterPlaceholder: 'Search...',
          limit: 'Records:',
          noResults: 'No matching records',

        }

      },
      CertificationTypes: [],
      AddCertificateForm: {

        Name: '',
        Description: ''
      },
      IsCertificateTypeEdit: false,
      CertificateTypeEditID: 0,
      SelectedStateName: '',
      organizationDetails: {},
      locations: [],
      pools: [],
      locationName: '',
      poolName: '',
      IsIdealRange: '1',
      selectedlocationId: '',
      selectedpoolId: '',
      editLocation: false,
      editPool: false,
      currentLocationName: '',
      currentPoolName: '',
      act: false,
      poolpromptVisible: false,
      locationpromptVisible: false,
      positionpromptVisible: false,
      currentRange: '',
      currentRange1: '',
      organizationName: '',
      locationFlag: false,
      orgEditorgEdit: false,
      tabName: 'first',
      position: '',
      positions: [],
      roles: [],
      editPosition: false,
      selectedpositionId: '',
      currentPositionName: '',
      roleModel: '',
      Selectedstatefilled: '',
      modalTitle: '',
      init: true,
      // options: [{
      //   value: 'PDT',
      //   label: 'PDT'
      // }, {
      //   value: 'MDT',
      //   label: 'MDT'
      // }, {
      //   value: 'CDT',
      //   label: 'CDT'
      // }, {
      //   value: 'EDT',
      //   label: 'EDT'
      // }],
      options: [],
      ranges: [],
      // Timezone:'',
      // Timezoneselected:''
      State: '',
      SelectedState: ''
    }
  },

  mounted() {
    this.ranges = [{
        value: true,
        label: 'Ideal Range'
      },
      {
        value: false,
        label: 'Full Range'
      }
    ]
    this.organizationDetails = {
      organizationId: authDetails.OrganizationId,
      organizationName: authDetails.OrganizationName
    }
    this.getLocations()
    this.getPositions()
    this.getRoles()
    this.GetCertificationTypes()

    this.getstates()
  },

  methods: {
    showcertificate() {

      let context = this
      this.modalTitle = 'Create Certificate'
      $('#AddCertificatemodel').modal('show')

      setTimeout(function () {
        context.$refs['AddCertificateForm'].resetFields()
      }, 10)
    },

    del: function (data) {

      var ID = data.row.Id

      let context = this
      context.$confirm('Are you sure you want to delete?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        loader.startLoader()
        service.DeleteCertificationType(ID).then(function (response) {

          context.GetCertificationTypes()

          loader.stopLoader()

          context.$notify({
            title: 'Success',
            message: 'Delected Successfully',
            type: 'success'
          })

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })
        // context.$message({
        //   type: 'success',
        //   message: 'Delete completed'
        // });
      }).catch(() => {

      })

    },

    cancelpopup: function () {
      this.IsCertificateTypeEdit = false
      $('#AddCertificatemodel').modal('hide')
    },
    getstates() {

      let context = this

      service.GetStates().then(function (response) {

        context.options = response

        context.options.unshift({
          "StateId": null,
          "StateName": "MAHC"

        })
        context.SelectedState = context.options[0].StateId
        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })
    },
    EditCertificateType: function (data) {
      let context = this
      var ID = this.CertificateTypeEditID
      if (ID !== 0) {
        let model = {
          Id: ID,
          Name: data.Name,
          Description: data.Description
        }
        loader.startLoader()
        service.UpdateCertificationType(model).then(function (response) {
          context.IsCertificateTypeEdit = false
          $('#AddCertificatemodel').modal('hide')
          context.CertificateTypeEditID = 0

          context.$notify({
            title: 'Success',
            message: 'Updated certificate type succesfully',
            type: 'success'
          })

          for (var i = 0; i < context.CertificationTypes.length; i++) {
            if (context.CertificationTypes[i].Id == ID) {

              context.CertificationTypes[i].Name = data.Name

              context.CertificationTypes[i].Description = data.Description
              break
            }
          }

          loader.stopLoader()

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }

    },

    editcol: function (data) {

      var ID = data.row.Id

      let context = this
      this.modalTitle = 'Edit Certificate'
      context.CertificateTypeEditID = ID
      for (var i = 0; i < context.CertificationTypes.length; i++) {
        if (context.CertificationTypes[i].Id == data.row.Id) {
          context.AddCertificateForm.Name = data.row.Name

          context.AddCertificateForm.Description = data.row.Description
          break
        }
      }
      context.IsCertificateTypeEdit = true

      $('#AddCertificatemodel').modal('show')

    },

    GetCertificationTypes() {
      let context = this
      loader.startLoader()
      service.GetCertificationTypes().then(function (response) {

        context.CertificationTypes = response
        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },

    submitForm(formName) {


      this.$refs[formName].validate((valid) => {


        if (valid) {

          let context = this
          loader.startLoader()

          let Model = {
            Name: context.AddCertificateForm.Name,
            Description: context.AddCertificateForm.Description
          }

          service.AddCertificationType(Model).then(function (response) {

            loader.stopLoader()
            $('#AddCertificatemodel').modal('hide')
            context.GetCertificationTypes()

          }, (error) => {

            loader.stopLoader()
            $('#AddCertificatemodel').modal('hide')
            this.$notify({

              title: 'Error',

              message: error.responseJSON.Message,

              type: 'error'

            })
          })

        } else {
          this.$notify({

            title: 'Error',

            message: 'LOC_POOS - error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    checkSpace() {

      if (this.organizationName) {
        this.organizationName = this.organizationName.replace(/^\s+|\s+$/g, '')

      }

      if (this.locationName) {
        this.locationName = this.locationName.replace(/^\s+|\s+$/g, '')
      }
      if (this.currentLocationName) {
        this.currentLocationName = this.currentLocationName.replace(/^\s+|\s+$/g, '')
      }
      if (this.poolName) {
        this.poolName = this.poolName.replace(/^\s+|\s+$/g, '')
      }
      if (this.currentPoolName) {
        this.currentPoolName = this.currentPoolName.replace(/^\s+|\s+$/g, '')
      }
      if (this.position) {
        this.position = this.position.replace(/^\s+|\s+$/g, '')
      }
      if (this.currentPositionName) {
        this.currentPositionName = this.currentPositionName.replace(/^\s+|\s+$/g, '')
      }
    },

    UpdateOrganization() {
      let context = this
      loader.startLoader()
      service.UpdateOrganization({
        OrganizationId: authDetails.OrganizationId,
        OrganizationName: this.organizationName
      }).then(function (response) {
        authDetails.OrganizationName = context.organizationName
        context.organizationDetails.organizationName = context.organizationName
        context.$localStorage.set('authentication', JSON.stringify(authDetails))
        context.orgEditorgEdit = false
        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },

    DeletePosition(positionId) {
      let context = this

      this.$confirm('This will permanently delete the position. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        loader.startLoader()

        service.DeletePosition(positionId).then(function (response) {

          for (var i = 0; i < context.positions.length; i++) {

            if (context.positions[i].PositionId == positionId) {
              context.positions.splice(i, 1)
              i--
            }
          }
          context.$notify({

            title: 'Success',

            message: 'Position deleted',

            type: 'success'

          })
          loader.stopLoader()

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }).catch(() => {

      })
    },

    updateRole(positionId, roleId, positionName) {
      let context = this

      let positionModel = {
        PositionId: positionId,
        RoleId: roleId,
        PositionName: positionName

      }
      let cfinish = false
      let i = 0

      let resTime = setInterval(function () {
        i = i++

          if (i > 10 && !cfinish) {
            loader.startLoader()
            clearInterval(resTime)
          }

      }, 10)

      service.updateRole(positionModel).then(function (response) {


        cfinish = true
        clearInterval(resTime)

        for (var i = 0; i < context.positions.length; i++) {

          if (context.positions[i].PositionId == positionId) {
            context.positions[i].PositionName = positionName
            context.currentPositionName = positionName
            context.selectedpositionId = ''
            context.editPosition = false
          }
        }

        loader.stopLoader()

      }, (error) => {
        cfinish = true
        clearInterval(resTime)
        loader.stopLoader()
        context.currentPositionName = positionName
        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })
    },
    addPosition() {
      let context = this
      loader.startLoader()

      let positionModel = {

        PositionName: this.position

      }

      service.AddPosition(positionModel).then(function (response) {

        if (!context.positions) {
          context.positions = []
        }

        context.positions.push({
          PositionId: response[0].PositionId,
          PositionName: context.position,
          RoleId: response[0].RoleId,
          RoleName: response[0].RoleName
        })

        context.position = ''
        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })
    },
    getLocations() {
      let context = this
      loader.startLoader()
      service.GetLocations().then(function (response) {

        context.locations = response

        if (response) {

          if (response.length > 0) {
            setTimeout(function () {

              context.$refs.locationTable.setCurrentRow(context.locations[0])

            }, 500)

            context.getPools(response[0].LocationId)
            context.selectedlocationId = response[0].LocationId
            context.currentLocationName = response[0].LocationName
          }
        }

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.error_description,

          type: 'error'

        })
      })

    },
    getPositions() {
      let context = this
      loader.startLoader()
      service.GetPositions().then(function (response) {

        context.positions = response

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.error_description,

          type: 'error'

        })
      })

    },
    getRoles() {
      let context = this
      loader.startLoader()
      service.GetRoles().then(function (response) {
        window.xt = JSON.stringify(response)

        context.roles = response

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.error_description,

          type: 'error'

        })
      })

    },
    getPools(locationId) {
      this.poolName = ''
      let context = this
      let cfinish = false
      let i = 0

      let resTime = setInterval(function () {
        i = i++

          if (i > 10 && !cfinish) {
            loader.startLoader()
            clearInterval(resTime)
          }

      }, 10)

      service.GetPoolsById(locationId).then(function (response) {
        cfinish = true
        context.pools = response
        clearInterval(resTime)
        if (response) {
          if (response.length > 0) {

            context.selectedpoolId = response[0].PoolId
            context.currentPoolName = response[0].PoolName
          }
        }

        loader.stopLoader()

      }, (error) => {
        cfinish = true
        clearInterval(resTime)
        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.error_description,

          type: 'error'

        })
      })

    },
    addPool() {
      let context = this
      loader.startLoader()

      service.AddPool({
        PoolName: this.poolName,
        LocationId: this.selectedlocationId
      }).then(function (response) {

        if (!context.pools) {
          context.pools = []
        }
        context.pools.push({
          PoolId: response.PoolId,
          PoolName: context.poolName
        })
        context.$router.app.$emit('invokePoolLoc')

        context.poolName = ''

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })
    },
    UpdatePool(poolid, poolname) {

      let context = this

      loader.startLoader()
      service.UpdatePool({
        PoolId: poolid,
        PoolName: poolname,
        LocationId: this.selectedlocationId
      }).then(function (response) {
        context.editPool = false
        context.$router.app.$emit('invokePoolLoc')
        for (var i = 0; i < context.pools.length; i++) {

          if (context.pools[i].PoolId == poolid) {
            context.pools[i].PoolName = poolname
            context.currentPoolName = poolname
          }
        }

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()
        context.currentPoolName = poolname
        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },
    DeletePool(poolid) {
      let context = this

      this.$confirm('This will permanently delete the Aquatic venue. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',

      }).then(() => {

        loader.startLoader()

        service.DeletePool(poolid).then(function (response) {

          context.$router.app.$emit('invokePoolLoc')
          for (var i = 0; i < context.pools.length; i++) {

            if (context.pools[i].PoolId == poolid) {
              context.pools.splice(i, 1)
              i--
            }
          }

          context.$notify({

            title: 'Success',

            message: 'Aquatic venue  deleted',

            type: 'success'

          })

          loader.stopLoader()

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }).catch(() => {
        /*     this.$message({
         type: 'info',
         message: 'Delete canceled'
         });*/
      })

    },
    DeleteLocation(locationid) {
      let context = this

      this.$confirm('This will permanently delete the Aquatic facility. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        loader.startLoader()

        service.DeleteLocation(locationid).then(function (response) {
          context.$router.app.$emit('invokePoolLoc')
          for (var i = 0; i < context.locations.length; i++) {

            if (context.locations[i].LocationId == locationid) {
              context.locations.splice(i, 1)
              i--
            }
          }

          context.$notify({

            title: 'Success',

            message: 'Aquatic facility deleted',

            type: 'success'

          })
          loader.stopLoader()

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }).catch(() => {

      })

    },
    selectlocationCell(row) {

      if (this.selectedlocationId != row.LocationId) {
        this.getPools(row.LocationId)
        this.editLocation = false
        this.locationFlag = false
      }

      if (this.selectedlocationId == row.LocationId) {
        this.locationFlag = true

      }
      if (!this.locationFlag) {

        this.currentLocationName = row.LocationName
        this.Selectedstatefilled = row.StateId
      }

      this.selectedlocationId = row.LocationId

    },
    selectpoolCell(row) {

      if (this.selectedpoolId != row.PoolId) {
        this.editPool = false
      }
      this.currentPoolName = row.PoolName
      this.selectedpoolId = row.PoolId

    },

    selectpositionCell(row) {

      //this.currentPositionName = row.PositionName
      // this.selectedpoolId = row.PositionId

    },
    addLocation() {
      let context = this
      loader.startLoader()

      let ir
      if (this.IsIdealRange == '1') {
        ir = true
      } else {
        ir = false
      }
      let model = {
        LocationName: this.locationName,
        StateId: this.SelectedState,
        IsIdealRange: ir
      }
      service.AddLocation(model).then(function (response) {
        context.$router.app.$emit('invokePoolLoc')
        context.IsIdealRange = '1'
        if (!context.locations) {
          context.locations = []
        } else {

          context.locations.push({
            LocationId: response.LocationId,
            LocationName: context.locationName,
            StateId: context.SelectedState,
            StateName: context.SelectedStateName
          })
          context.locationName = ''
          context.State = ''
          context.SelectedState = ''
        }

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },
    findlocationname(SelectedStateID) {

      if (this.options && SelectedStateID != null) {

        for (var i = 0; i < this.options.length; i++) {
          if (this.options[i].StateId == SelectedStateID) {
            this.SelectedStateName = this.options[i].StateName
            break
          }
        }
      }

    },
    lrChange(val) {

      if (val == '1') {
        this.currentRange = '2'

      } else {
        this.currentRange = '1'

      }
    },
    UpdateLocation(locationid, locationname, currentRange, StateId) {
      let context = this

      loader.startLoader()
      service.UpdateLocation({
        LocationId: locationid,
        LocationName: locationname,
        IsIdealRange: currentRange,
        StateId: StateId
      }).then(function (response) {
        context.editLocation = false
        context.$router.app.$emit('invokePoolLoc')

        // context.locations.push({LocationId: response.LocationId, LocationName: context.locationName,StateId: context.SelectedState,StateName:context.SelectedStateName })
        // for (var i = 0; i < context.locations.length; i++) {

        //   if (context.locations[i].LocationId == locationid) {
        //     context.locations[i].LocationName = locationname
        //     context.locations[i].StateId = StateId,
        //     context.locations[i].StateName=context.SelectedStateName
        //     context.currentLocationName = locationname,
        //       context.LocationOffset=StateId
        //   }
        // }

        context.getLocations()

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()
        context.currentLocationName = locationname
        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },

    handleCurrentChange(item) {

    },

  }

}



// WEBPACK FOOTER //
// ./src/pages/Administration/location_pools.controller.js